// PricelistRow.js
import React from "react";
import { Box, TextField, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteForever";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { NumericFormat } from "react-number-format";
import { FormattedMessage, useIntl } from "react-intl";

const rowStyle = {
  display: "grid",
  gridTemplateColumns: "28px 1.2fr 0.4fr 0.6fr 0.6fr 1.5fr auto", // adjusted amount column
  gap: "10px",
  backgroundColor: "white",
  alignItems: "center",
};

const PricelistRow = ({ dragHandleProps, row, index, onAddRow, onDeleteRow, onChangeRow, disableDelete }) => {
  const handleFieldChange = (field, value) => {
    onChangeRow(index, field, value);
  };
  const intl = useIntl();

  return (
    <Box sx={rowStyle} >
      <Box
        {...dragHandleProps}
        sx={{
          cursor: "grab",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 32,
          height: 32,
          mr: 1,
        }}
      ><DragIndicatorIcon sx={{ cursor: "grab" }} /></Box>

      <TextField
        value={row.artNo}
        onChange={(e) => handleFieldChange("artNo", e.target.value)}
        size="small"
      />
      <TextField
        type="number"
        value={row.amount}
        onChange={(e) => handleFieldChange("amount", parseFloat(e.target.value))}
        inputProps={{
          style: {
            textAlign: "right"
          }
        }}
        size="small"
      />

      <NumericFormat
        value={row.price}
        thousandSeparator=" "
        decimalSeparator=","
        decimalScale={2}
        fixedDecimalScale
        allowNegative={false}
        customInput={TextField}
        onValueChange={(values) => onChangeRow(index, "price", values.floatValue)}
        size="small"
        inputProps={{ style: { textAlign: "right" } }}
      />

      <NumericFormat
        value={row.productionCost}
        thousandSeparator=" "
        decimalSeparator=","
        decimalScale={2}
        fixedDecimalScale
        allowNegative={false}
        customInput={TextField}
        onValueChange={(values) => onChangeRow(index, "productionCost", values.floatValue)}
        size="small"
        inputProps={{ style: { textAlign: "right" } }}
      />

      <TextField
        value={row.shortDescription}
        onChange={(e) => handleFieldChange("shortDescription", e.target.value)}
        size="small"
      />
      <Box>
        <IconButton
          onClick={() => onAddRow(index)}
          aria-label={intl.formatMessage({ id: "admin.pricelists.rows.add" })}
          title={intl.formatMessage({ id: "admin.pricelists.rows.add" })}
        >
          <AddIcon />
        </IconButton>
        <IconButton
          disabled={disableDelete}
          onClick={() => onDeleteRow(index)}
          aria-label={intl.formatMessage({ id: "admin.pricelists.rows.delete" })}
          title={intl.formatMessage({ id: "admin.pricelists.rows.delete" })}
        >
          <DeleteIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default PricelistRow;
